import React from 'react'
import Modal from 'components/Modal';

import { Player } from 'video-react';

import { Container } from './styles'

const PlayerModal = ({ open, close, source }) => {

  const closeModal = () => {
    close(false);
  };

  return (

    <Modal
      isOpen={open}
      toggle={() => closeModal()}
      title="Vídeo"
    >
      <Player fluid={false} width={570} height={400}>
        <source src={source} />
      </Player>
    </Modal>
  )
}

export default PlayerModal
